import api from '../api/api';

const videoService = {
  /**
   * Get protected video stream URL with watermark and session tracking
   */
  getVideoStreamUrl: async (videoId) => {
    try {
      const response = await api.get(`/videos/cf-stream/${videoId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Get video stream URL with range support for better seeking
   */
  getVideoStreamUrlWithRange: async (videoId, range = null) => {
    try {
      const params = range ? { range } : {};
      const response = await api.get(`/videos/stream/${videoId}/range`, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },


  /**
   * Get videos for a specific course (enrolled users only)
   */
  getCourseVideos: async (courseId) => {
    try {
      const response = await api.get(`/videos/course/${courseId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Get video details by ID (enrolled users only)
   */
  getVideoById: async (videoId) => {
    try {
      const response = await api.get(`/videos/${videoId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Check if user has access to a video
   */
  checkVideoAccess: async (videoId) => {
    try {
      const response = await api.get(`/videos/${videoId}`);
      return response.data.success;
    } catch (error) {
      return false;
    }
  }
};

export default videoService;
